import React, { useState, useRef, useEffect } from "react";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";

const CommonDateRange = ({
  initialStartDate = null,
  initialEndDate = null,
  onApply,
  datePrefield = true,
}) => {
  const isAllTime = !initialStartDate && !initialEndDate;

  const [range, setRange] = useState({
    startDate: initialStartDate ? moment(initialStartDate) : null,
    endDate: initialEndDate ? moment(initialEndDate) : null,
  });

  const [placeHolderValues, setPlaceHolderValues] = useState({
    startDate: "",
    endDate: "",
  });

  useEffect(() => {
    setRange({
      startDate: initialStartDate ? moment(initialStartDate) : null,
      endDate: initialEndDate ? moment(initialEndDate) : null,
    });

    setPlaceHolderValues({
      startDate: initialStartDate || "",
      endDate: initialEndDate || "",
    });
  }, [initialStartDate, initialEndDate]);

  const pickerRef = useRef(null);

  const handleEvent = (event, picker) => {
    const isAllTimeSelected =
      picker.chosenLabel === "All Time" || !picker.startDate || !picker.endDate;

    const newRange = isAllTimeSelected
      ? { startDate: null, endDate: null }
      : {
          startDate: picker.startDate,
          endDate: picker.endDate,
        };

    setPlaceHolderValues(newRange);
    setRange(newRange);

    picker.hide();

    if (onApply) {
      onApply(newRange);
    }
  };

  const ranges = {
    "All Time": [null, null], // special case
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  const displayValue =
    range.startDate && range.endDate
      ? `${range.startDate.format("MMMM D, YYYY")} - ${range.endDate.format(
          "MMMM D, YYYY"
        )}`
      : "All Time";

  return (
    <DateRangePicker
      initialSettings={{
        startDate:
          range.startDate?.toDate() || moment().subtract(32, "days").toDate(),
        endDate: range.endDate?.toDate() || moment().toDate(),
        ranges,
        locale: { format: "MMMM D, YYYY" },
      }}
      onApply={handleEvent}
      ref={pickerRef}
    >
      <div className="input-group anvCustom_floatInput form-floating">
        <input
          type="text"
          label="Select Date Range"
          className="form-control"
          placeholder="Select Date Range"
          value={
            !datePrefield && !placeHolderValues?.startDate ? "" : displayValue
          }
          readOnly
        />
        <label htmlFor="floatingInput">
          <span>Select Date Range</span>
        </label>
      </div>
    </DateRangePicker>
  );
};

export default CommonDateRange;
